import { action } from 'typesafe-actions';
import { Search } from '../../model/search';
import { SearchActionTypes } from './types';

export const saveSearch = (search: Search) => action(SearchActionTypes.SAVE_SEARCH, search);